// src/components/Admin/adminUtils.js
// Helpers compartidos por los tabs del Admin Dashboard - sin dependencias externas.

export const startOfDay = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};

export const addDays = (date, days) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};

export const startOfWeek = (date) => {
  const d = startOfDay(date);
  const day = d.getDay(); // 0 = domingo
  const diff = (day === 0 ? -6 : 1) - day; // lunes como inicio de semana
  return addDays(d, diff);
};

export const startOfMonth = (date) => new Date(date.getFullYear(), date.getMonth(), 1);

export const money = (n) =>
  (n || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });

export const totalNights = (checkIn, checkOut) => {
  const d = (new Date(checkOut) - new Date(checkIn)) / (1000 * 60 * 60 * 24);
  return Math.max(Math.round(d), 0);
};

// Mismo criterio que el endpoint getDashboardStats del backend: una reserva
// "pending" aún no está confirmada, así que no cuenta como ingreso real.
export const REVENUE_STATUSES = ['confirmed', 'checked-in', 'checked-out', 'completed'];